import { get } from 'lodash';

import userMixin from './user';

export default {
  mixins: [userMixin],
  methods: {
    hasAccessCompany(company) {
      const parentId = get(company, 'parent.id', 0);
      return this.isMyCompany(company.id) || this.amISystemAdmin || this.isMyCompany(parentId);
    },
    canICreateCompany(parentId = null) {
      const haveAccess = this.iHaveAccess('MAIN.COMPANY.CREATE');
      if (parentId === null) {
        return haveAccess && this.amISystemAdmin;
      }

      return haveAccess &&
        (this.amISystemAdmin || this.isMyCompany(parentId));
    },
    canIEditCompany(company) {
      return this.iHaveAccess('MAIN.COMPANY.UPDATE') &&
        this.hasAccessCompany(company);
    },
    canIDeleteCompany(company) {
      const loggedInCompany = this.loggedInUserData.company || {};
      const lCompanyId = loggedInCompany.id || -1;
      const companyId = company.id || -2;
      const parentId = get(company, 'parent.id', 0);

      const notMyCompany = (lCompanyId.toString() !== companyId.toString()) &&
        (this.amISystemAdmin || this.isMyCompany(companyId) || this.isMyCompany(parentId));
      return this.iHaveAccess('MAIN.COMPANY.DELETE') &&
        notMyCompany;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/company.js